<template>
  <SiruiSearch
    ref="formItem"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    :isDisabledForm="isDisabledForm"
    @changeMethod="changeMethod"
  >
  </SiruiSearch>
</template>

<script>
  import { baseForm, baseFormRule } from './index.js';
  import BASE_API from '@/api/dataBase';
  import { formatDate } from '@/utils';
  export default {
    name: 'AgreementForm',
    props: {
      // 远程数据
      fetchFormData: {
        type: Object,
        default: () => {},
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
      // 不定价
      isDisabledPricingRule: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      fetchFormData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.baseFormData = val;
            // 判断禁用
            if (val.isDefault) {
              if (val.liquidatedDamagesType == 'RATE') {
                this.disabledFieldList = ['liquidatedFixedValue'];
              } else {
                this.disabledFieldList = ['liquidatedInterestRate'];
              }
            } else {
              this.disabledFieldList = [
                'liquidatedDamagesType',
                'liquidatedFixedValue',
                'liquidatedInterestRate',
              ];
            }
            this.getProjectByProjectNo(this.baseFormData.projectInitiationNo);
            this._getCompanyApi();
            this.$refs.formItem.clearValidate();
          }
        },
        immediate: true,
        deep: true,
      },
      isDisabledPricingRule: {
        handler(val) {
          console.log(val, '监听是否定价');
          this.baseFormData = {
            ...this.baseFormData,
            isFixedPrice: val ? '1' : '0',
          };
        },
        immediate: true,
      },
    },
    data() {
      return {
        baseFormData: {
          version: null,
          projectInitiationNo: '',
          projectName: '',
          supplierNo: '',
          supplierName: '',
          contractName: '',
          contractNo: '',
          contractType: '',
          signDate: '',
          contractValidStart: '',
          contractValidEnd: '',
          departmentCode: '',
          companyCode: '',
          contractCreateDate: '',
          contractOperaterName: '',
          platformCompanyFileNo: '',
          platformCompanyName: '',
          isDefault: '0',
          liquidatedDamagesType: '',
          liquidatedFixedValue: '',
          liquidatedInterestRate: '',
          creditAmount: '',
          isFixedPrice: '0',
          pricingRule: '',
          marginAmount: '',
          businessType: '',
          receiptMethod: '',
          companyCurrency: '',
          overShippedPercentage: '',
          shortShippedPercentage: '',
          lastestReceiveProductDay: '',
          lastestPayMoneyDay: '',
          incomeMethod: '',
          isRestrict: '',
          isLongRange: '',
          externalContractNo: '',
        },
        currencyList: [],
        departmentList: [], //业务部门
        companyList: [], //公司
        platformCompanyFileList: [],
        isCreate: false,
        disabledFieldList: [], //禁用列表
      };
    },
    computed: {
      formColumn() {
        return baseForm(this);
      },
      formRules() {
        return baseFormRule(this);
      },
    },
    mounted() {
      this.isCreate = this.$route.query.status == 'create';
      this._getCurrency();
      this._initFormData();
      this._initDisabledList();
    },
    methods: {
      closeTableHandler(tableData = []) {
        // 处理定价
        const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == '0');
        this.isDisabledPricingRule = isFixedPriceResult;
        console.log(this.isDisabledPricingRule, '当前是否的定价');
      },
      // 初始化数据
      _initFormData() {
        if (this.isCreate) {
          console.log('初始化表单数据----');
          this.baseFormData = {
            ...this.baseFormData,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            contractOperaterNo: this.userInfo.userCode,
            contractOperaterName: this.userInfo.personName,
            isNotEndDate: '1',
            contractCreateDate: formatDate(new Date()),
            companyCurrency: 'CNY',
            companyCurrencyName: '中国人民币（国际）',
            contractCurrency: 'CNY',
            contractCurrencyName: '中国人民币（国际）',
            incomeMethod: 'FIXED',
          };
          this._getCompanyApi();
        }
      },
      // 初始化禁用列表
      _initDisabledList() {
        if (this.isCreate) {
          this.disabledFieldList = [
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
          ];
        }
      },
      // 获取币种
      async _getCurrency() {
        const { data } = await this.$axios.get(BASE_API.LIST_CURRENCY);
        if (data.code == 0) {
          this.currencyList = data.data.map((item) => {
            return {
              label: item.currencyName,
              value: item.currencyCode,
            };
          });
        }
      },
      // 切割平台公司
      splitPlatformtCompanyList(platformtCompany, platformtCompanyName) {
        if (platformtCompany && platformtCompanyName) {
          const platformtCompanyList = platformtCompany.split(',');
          const platformtCompanyNameList = platformtCompanyName.split(',');
          this.platformCompanyFileList = platformtCompanyList.map((item, index) => {
            return {
              label: platformtCompanyNameList[index],
              value: item,
            };
          });
        } else {
          this.platformCompanyFileList = [];
        }
      },
      changeMethod({ prop, val }) {
        console.log(prop, val, '切换选择');
        // 项目编号
        if (prop == 'projectInitiationNo') {
          const rowData = val[0];
          console.log('rowData', rowData?.projectInitiationNo, rowData?.projectName);
          this.baseFormData.projectInitiationNo = rowData?.projectInitiationNo;
          this.baseFormData.projectName = rowData?.projectName;
          this.baseFormData.platformCompanyFileNo = '';
          this.baseFormData.platformCompanyName = '';
          this.platformCompanyFileList = [];
          if (rowData) {
            // const recyclingtCompany = rowData?.recyclingtCompany;
            // const recyclingtCompanyName = rowData?.recyclingtCompanyName;
            const platformtCompany = rowData?.platformtCompany;
            const platformtCompanyName = rowData?.platformtCompanyName;
            // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
            this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
          }
        } else if (prop == 'supplierNo') {
          // 修改供应商是否禁用开启协议
          const {
            partnerCode,
            partnerZhName,
            // departmentName,
            // departmentCode,
            isRelatedParty,
            ifPersonalPartner,
            partnerType,
            // companyCode,
            identityNo,
          } = val[0];
          console.log(
            partnerCode,
            partnerZhName,
            isRelatedParty,
            partnerType,
            '供应商',
            this.baseFormData.companyCode
          );
          this.baseFormData = {
            ...this.baseFormData,
            isGenerateSales: false,
            supplierNo: partnerCode,
            supplierName: partnerZhName,
            identityNo,
            isRelatedParty,
            partnerType,
            ifPersonalPartner,
          };
        } else if (prop == 'companyCode') {
          // 选择公司
          const currentItem = this.companyList.find((item) => item.personCompanyCode == val);
          this.baseFormData = {
            ...this.baseFormData,
            departmentCode: '',
            departmentName: '',
            supplierNo: '',
            supplierName: '',
            companyCode: val,
            companyName: currentItem?.personCompanyName,
            isGenerateSales: false,
          };
          if (val) {
            this._getDepartmentByCompanyCodeApi(val);
          }
          // 重置表格数据
          this.$refs.orderDetailListRef?.resetTable();
        } else if (prop === 'departmentCode') {
          // 选择部门的时候
          const currentItem = this.departmentList.find((item) => item.value == val);
          this.baseFormData = {
            ...this.baseFormData,
            departmentCode: val,
            departmentName: currentItem?.label,
          };
        } else if (prop == 'platformCompanyFileNo') {
          // 回收编码
          // this.baseFormData.platformCompanyFileNo = val;
          const item = this.platformCompanyFileList.find((item) => item.value == val);
          // this.baseFormData.platformCompanyName = item?.label;

          this.baseFormData = {
            ...this.baseFormData,
            platformCompanyFileNo: val,
            platformCompanyName: item?.label,
          };
        } else if (prop == 'isDefault') {
          if (val == '1') {
            //wumaoFix
            this.baseFormData = {
              ...this.baseFormData,
              liquidatedDamagesType: 'RATE',
              liquidatedDamagesName: '按利率',
            };
            this.disabledFieldList = this.disabledFieldList.filter((item) => {
              return item != 'liquidatedDamagesType' && item != 'liquidatedInterestRate';
            });
          } else {
            this.baseFormData = {
              ...this.baseFormData,
              liquidatedDamagesType: '',
              liquidatedDamagesName: '',
              liquidatedFixedValue: '',
              liquidatedInterestRate: '',
            };
            this.disabledFieldList = [
              'liquidatedDamagesType',
              'liquidatedFixedValue',
              'liquidatedInterestRate',
            ];
            console.log('000', this.disabledFieldList);
          }
        } else if (prop == 'liquidatedDamagesType') {
          console.log('合同违约金类型', val);
          if (val == 'RATE') {
            this.disabledFieldList = ['liquidatedFixedValue'];
            this.baseFormData.liquidatedFixedValue = '';
            this.baseFormData.liquidatedDamagesName = '按利率';
          } else {
            this.disabledFieldList = ['liquidatedInterestRate'];
            this.baseFormData.liquidatedInterestRate = '';
            this.baseFormData.liquidatedDamagesName = '按固定值';
          }
        } else if (prop == 'companyCurrency') {
          this.baseFormData.companyCurrency = val;
          this.baseFormData.companyCurrencyName = this.currencyList.find(
            (item) => item.value == val
          )?.label;
        }
      },
      async getValidateFormData() {
        let formData = await this.$refs.formItem.getValidateFormData();
        const currentStatus = this.$route.query.status;
        // TODO 特殊处理 还没找到原因
        if (formData.supplierNo && Array.isArray(formData.supplierNo)) {
          const {
            partnerCode,
            partnerZhName,
            isRelatedParty,
            ifPersonalPartner,
            partnerType,
            identityNo,
          } = formData.supplierNo[0];
          formData = {
            ...formData,
            isGenerateSales: false,
            supplierNo: partnerCode,
            supplierName: partnerZhName,
            identityNo,
            isRelatedParty,
            partnerType,
            ifPersonalPartner,
          };
        }

        return {
          ...formData,
          // 几个额外字段
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          adminFlag: this.userInfo.adminFlag,
          // 特殊处理id
          id:
            ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
              ? ''
              : formData?.id,
        };
      },
      // 获取公司
      async _getCompanyApi() {
        this.loading.startLoading();
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        this.loading.endLoading();
        if (data.code == 0) {
          this.companyList = data.data?.personCompanyInfo;
          // 默认初始化全部表单数据
          if (this.baseFormData.companyCode) {
            // 获取部门下拉
            this._getDepartmentByCompanyCodeApi(this.baseFormData.companyCode);
          }
        } else {
          console.error('获取公司失败');
        }
      },
      async getProjectByProjectNo(projectInitiationNo) {
        const { data } = await this.$axios.post('/sales/goodsTradeProject/purchaseContractPage', {
          projectInitiationNo,
        });
        if (data.code == 0) {
          const rowData = data.data[0];
          const platformtCompany = rowData.platformtCompany;
          const platformtCompanyName = rowData.platformtCompanyName;
          // const recyclingtCompany = rowData.recyclingtCompany;
          // const recyclingtCompanyName = rowData.recyclingtCompanyName;
          // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
          this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
        } else {
          console.error('根据项目号获取项目信息失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        if (companyCode) {
          const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          });
          if (data.code == 0) {
            this.departmentList = data.data?.personDepartmentInfo.map((item) => {
              return {
                label: item.personDepartmentName,
                value: item.personDepartmentCode,
              };
            });
          } else {
            console.error('获取部门失败');
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
